<!-- Jumbotron -->
<div *ngIf="loading" class="loading-indicator">
  <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
</div>

<div id="divLogin" class="flexContainer" style="visibility: collapse;">
  
    <div class="padd15" >
      <div width="250" alt="Thomson Reuters" class="trIcon"></div>
      <div class="paddBott30" #fixheight>
        <div class="txtCenter">
          <h1 class="card-title">{{InstanceTitle}}</h1>
          <p class="card-title">{{InstanceInfo}}</p>
        </div>
        <div id="divgetStartedInstance" class="infoContainer">
          <div class="flexHalf padd15">
            <img width="80" alt="{{LoginPart1Heading}}" class="" src="../../assets/img/content-sharing.svg">
            <br />
            <p class="blue-text my-4 font-weight-bold"></p>
            <h4 class="h4">{{LoginPart1Heading}}</h4>
            <p class="blue-text my-4 font-weight-bold">{{LoginPart1Information}}</p>
            <b></b>
          </div>
          <div class="flexHalf padd15">
            <img width="80" alt="{{LoginPart2Heading}}" class="" src="../../assets/img/upload.svg">
            <br />
            <p class="blue-text my-4 font-weight-bold"></p>
            <h4 class="h4">{{LoginPart2Heading}}</h4>

            <p class="blue-text my-4 font-weight-bold">{{LoginPart2Information}}</p>
            <b></b>
          </div>
        </div>
      </div>
      <div class="fixedBott" #scrollheight>
        <p class="card-title">{{LoginInfoTap}} <strong>‘{{LoginGetStartedButtonText}}’</strong> {{LoginInfoTapEnd}} </p>
        <button mat-raised-button id="getStarted" aria-label="Get started" type="submit" class="msTeam-btn" (click)="btnGetStartedClick()">{{LoginGetStartedButtonText}}</button>
        <br />
        <div class="KnowledgeContainertop">
          {{HighQDemoText}}<a id="getHighQDemo" aria-label="HighQ Demo" href="{{HighQDemoLink}}" target="_blank">{{HighQDemoLinkText}}</a>{{HighQDemoTextEnd}}
        </div>
        <div class="KnowledgeContainer">
          {{LoginKBNoteText}}<a id="getKCHelp" aria-label="Knowledge base" href="{{KnowledgebaseLink}}" target="_blank">{{LoginKBNoteLinkText}}</a>
        </div>
      </div>
    </div>
  
</div>
<div class="global-footer add-divider" style=" position: absolute; bottom: 0; left: 0; right: 0;" *ngIf="errorMsg.length >0 && !loading">
  <div style="padding-top: 12px;"></div>
  <div class="loginerror" [innerHTML]="errorMsg"></div>
</div>


